import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssessmentService } from 'src/app/services/assessment.service';
import { ContentAuthoringService } from 'src/app/services/content-authoring.service';

import { CourseService } from 'src/app/services/course.service';

@Component({
  selector: 'app-manage-assessments',
  templateUrl: './manage-assessments.component.html',
  styleUrls: ['./manage-assessments.component.scss'],
  providers: [DatePipe]
})
export class ManageAssessmentsComponent implements OnInit {

  minDate = new Date();
  activeCourse: boolean = true;
  succesCourse: boolean = false;
  closeResult = ''; courseData: any = []; assessmentDetails: any = []; courseIdEndDate: any = '';
  status: any = 1; adminData: any; tabName: any = ''; assessment_id: any = '';
  courseListData: any = []; tabIndex: number = 0; page: any = '';
  assesment_name = ""; capsules_status = "2"; is_active = "1"; order_by = "created_dttm"; order = "DESC";
  courseForm: any = []; moduleData: any = [];
  extendForm = new FormGroup({
    endDate: new FormControl(new Date(), [Validators.required]),
  });
  manageAssesmentListData: any;
  get fv() { return this.extendForm.controls; }

  constructor(private modalService: NgbModal, private contentAuthoringApi: ContentAuthoringService, private router: Router,
    private spinner: NgxSpinnerService, private authCours: CourseService, private route: ActivatedRoute, private datePipe: DatePipe, private auth: AssessmentService) {
    if (localStorage.getItem('adminData') == '' || localStorage.getItem('adminData') == null) {
      this.router.navigateByUrl('/admin-login');
    }
  }
  ngOnInit(): void {
    this.is_active = '1';
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.authCours.lastSelectedTab.subscribe(res=> {
      this.tabIndex=res;
    })
    this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);

    this.route.queryParams.subscribe(queryParams => {
      this.tabIndex = queryParams['tab'];
      if (this.tabIndex == 2) {
        this.capsules_status = '1';
        this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
      }
      if (this.tabIndex == 1) {
        this.is_active = '0';
        this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
      }
    })

 
  }

  open0(content02: any, corseId: any) {
    this.courseIdEndDate = corseId;
    this.modalService.open(content02, { centered: true, size: 'md' });
  }
 
  open(content: any, data: any, tab_name: any) {
    this.tabName = tab_name;
    this.assessmentDetails = data
    this.assessment_id = data.assessment_id;
    this.modalService.open(content, { size: 'sm', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    //this.succesDelAssessment = false;
    //.activeDleMod = true;
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  /*******status change in active or deactive  *****/
  changeIsDeActiveVal(is_actives: any) {
    this.changeIsActiveVal( is_actives);
  }
  assessmentPublised() {
    this.authCours.AssessmentPublish(this.assessment_id).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
          // this.router.navigate(['/courses']);
        } else {
          // this.errorInfo.isError = true;
          // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  changeIsActiveVal(is_active: any) {
    //console.log(assessment_id,is_active);
    this.authCours.changeAssIsActiveVal(this.assessment_id, is_active).subscribe(
      (data) => {
        // console.log(data);
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
          this.router.navigate(['/manage-assessments']);
        } else {
          // this.errorInfo.isError = true;
          // this.errorInfo.errorMsg = 'No data Exist'
        }
      },
      (error) => {
        //this.errorInfo.errorMsg = error;
      },
    );
  }
  /*******delete course from draft *****/
  deleteAssessment() {
    this.authCours.deleteAssessment(this.assessment_id).subscribe(
      (data) => {
        if (data.status == 200) {
          document.getElementById('closelId')?.click();
          this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
        } else {
        }
      },
      (error) => { },
    );
  }
  /***** Shorting listing by course name****/
  sortData(sort: any) {
    if (sort.direction == 'desc') {
      this.order_by = sort.active; this.order = 'DESC';
    } else if (sort.direction == 'asc') {
      this.order_by = sort.active; this.order = 'ASC';
    } else { this.order_by = 'end_date'; this.order = 'DESC'; }
    this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  onSelectChange(event: any) {
   
    this.authCours.lastSelectedTab.next(event.index)
    if (event.index == 1) { //deactive
      this.is_active = '0';
      this.capsules_status = '2';
    }
    else if (event.index == 2) { // draft
      this.is_active = '0';
      this.capsules_status = '1';
    } else {
      this.is_active = '1';
      this.capsules_status = '2'; //active
    }
    this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  /****serach by course name */
  search(event: any) {
    this.assesment_name = event.target.value;
    this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  /*******get listing course data***/
  manageAssesmentList(searchText: any, is_active: any, capsules_status: any = this.capsules_status, order_by: any = this.order_by, order: any = this.order) {
    //this.spinner.show();
    this.authCours.manageAsseesment(searchText, is_active, capsules_status, order_by, order).subscribe(
      data => {
        if (data.status == 201 || data.status == 200) {
          this.manageAssesmentListData = data.contentCapsules;
         // this.spinner.hide();
        } else {
         // this.spinner.hide();
        }
      }, error => {
       // this.spinner.hide();
      }
    );
  }
  /*log out*/
  logout() {
    //localStorage.clear();
    localStorage.removeItem('adminLoginPass');
    localStorage.removeItem('adminData');
    this.router.navigate(['./admin-login']);
  }
  
  /******create duplicate course */
  duplicateAssessment(tab_name: any) {
    /*****get couse detail ****/
    this.spinner.show();
    this.auth.assessmentDetail(this.assessment_id).subscribe(
      data => {
        this.assessmentDetails = data.data;
        this.authCours.dublicateAssessment(this.assessmentDetails).subscribe(
          (data) => {
            if (data.status == 201) {
              this.spinner.hide();
              document.getElementById('closelId')?.click();
              if (tab_name == 'Active') {
                this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
              } else if (tab_name == 'Deactivated') {
                this.manageAssesmentList(this.assesment_name, 0, 2, this.order_by, this.order);
              } else {
                this.manageAssesmentList(this.assesment_name, 1, 1, this.order_by, this.order);
              }
              this.spinner.hide();
            }
          }, error => {
            this.spinner.hide();
          })
      })
  }

  /*****create duplicate modules of course */
  duplicateModule(Modueldata: any, tab_name: any, status: any) {
    this.authCours.creatModule(Modueldata, 'create').subscribe(
      data => {
        if (status == 1) {
          if (tab_name == 'Active') {
            this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
          } else if (tab_name == 'Deactivated') {
            this.manageAssesmentList(this.assesment_name, 0, 2, this.order_by, this.order);
          } else {
            this.manageAssesmentList(this.assesment_name, 1, 1, this.order_by, this.order);
          }
          document.getElementById('closelId')?.click();
          this.spinner.hide();
        }

      }, error => {
        this.spinner.hide();
      })

  }
  successExtendDate() {
    console.log(this.datePipe.transform(this.extendForm.controls.endDate.value, 'YYYY-MM-dd h:mm:ss'))
    this.authCours.courseEndDateUpdate(this.courseIdEndDate, this.datePipe.transform(this.extendForm.controls.endDate.value, 'YYYY-MM-dd h:mm:ss')).subscribe(
      data => {
        if (data.status == 200) {
          this.activeCourse = false;
          this.succesCourse = true;
        }
      }, error => { })
  }
  successDate() {
    this.activeCourse = true;
    this.succesCourse = false;
    document.getElementById('closelId')?.click();
    this.manageAssesmentList(this.assesment_name, this.is_active, this.capsules_status, this.order_by, this.order);
  }
  cousreEndDate(endDate: any) {
    var date2 = new Date();
    var date1 = new Date(endDate);
    var Time = date2.getTime() - date1.getTime();
    var Days = Time / (1000 * 3600 * 24);
    return Days;
  }
}
